import React from 'react'

import Footer from '~/components/Footer/FooterGql'
import Modal from '~/components/Modal'
import { commonModals } from '~/components/Modal/modalsList'

export default ({ regulation = {} }) => (
  <>
    <div className='regulation'>
      <div className='regulation__heading-container'>
        <h1 className='regulation__heading container'>{regulation.title}</h1>
      </div>
      <div
        className='regulation__content container'
        dangerouslySetInnerHTML={{ __html: regulation.richText }}
      />
    </div>
    <Footer />
    <Modal components={commonModals} />
  </>
)
